module.exports = __webpack_public_path__ + "static/media/users.f4174f57.svg";